import { createContainer } from 'react-sweet-state';

import {
  type Actions,
  BrandBriefsStore,
  type ContainerProps,
  type State,
} from './BrandBriefsStore';

export const BrandBriefsStoreContainer = createContainer<State, Actions, ContainerProps>(
  BrandBriefsStore,
  {
    onInit:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
    onUpdate:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
  }
);
